import React from 'react'
import { Card, CardContent, CardHeader } from '@/components/ui/card'

export type SubLoadingStateProps = Record<string, never>
export const SubLoadingState = ({}: SubLoadingStateProps) => {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Fixed header */}
      <header className="sticky top-0 z-10 bg-background border-b">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            {/* Title */}
            <div className="flex justify-center sm:justify-start">
              <h1 className="text-xl sm:text-2xl font-bold">Subscription Dashboard</h1>
            </div>
            {/* Loading placeholder for user info */}
            <div className="h-10 w-32 bg-muted animate-pulse rounded-md" />
          </div>
        </div>
      </header>

      {/* Scrollable content */}
      <main className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="grid gap-6 md:grid-cols-2 md:gap-8">
            {/* Main Content Loading State */}
            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <div className="h-6 w-32 bg-muted animate-pulse rounded-md mb-2" />
                  <div className="h-4 w-48 bg-muted animate-pulse rounded-md" />
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {[1, 2, 3].map((i) => (
                      <div
                        key={i}
                        className="flex items-start gap-2.5 p-2.5 sm:p-3 rounded-lg bg-secondary/50"
                      >
                        <div className="h-6 w-6 bg-muted animate-pulse rounded-full" />
                        <div className="flex-1 space-y-2">
                          <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
                          <div className="h-3 w-48 bg-muted animate-pulse rounded-md" />
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Sidebar Loading State */}
            <div className="space-y-6">
              <Card>
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
                    <div className="h-8 w-8 bg-muted animate-pulse rounded-md" />
                  </div>
                  <div className="h-4 w-32 bg-muted animate-pulse rounded-md mt-2" />
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="flex items-center justify-between py-2 border-b">
                        <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
                        <div className="h-4 w-12 bg-muted animate-pulse rounded-md" />
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
